/**
 * Tamaño del QR estático. Cualquier cambio aquí rompe compatibilidad con
 * QRs ya emitidos (PWA, Apple Wallet, Google Wallet) — versionar el
 * algoritmo si necesitas cambiar.
 */

export const QR_ID_BYTES = 12; // ObjectId
export const HMAC_BYTES = 16; // primeros 128 bits de HMAC-SHA256
export const PAYLOAD_BYTES = QR_ID_BYTES + HMAC_BYTES;
